import { callQueue } from "./callQueue";
import { QueueMethods } from "./Queue/Queue.interface";

/**
 * Function to handle polling a queue for results.
 *
 * @param {Object} params - The parameters for the polling function.
 * @param {QueueMethods} params.method - The method to call on the queue.
 * @param {InputType} params.data - The data to send with the queue call.
 * @param {number} [params.maxPoll=20] - The maximum number of polling attempts.
 * @param {number} [params.pollInterval=2000] - The interval between polling attempts in milliseconds.
 * @param {Function} params.setData - The function to call with the result data.
 *
 * @returns {number | undefined} - The interval handle, if polling is initiated.
 */
export default function pollingQueue<InputType, OutputType>({
  method,
  input,
  setData,
  maxPoll = 20,
  pollInterval = 2000,
}: {
  method: QueueMethods;
  input: InputType;
  setData: (data: OutputType) => void;
  maxPoll?: number;
  pollInterval?: number;
}) {
  let count = 0;
  let intervalHandle: number | undefined = undefined;

  console.log("Initiate Queue:", method);
  callQueue({
    method,
    data: input,
  }).then((initResult) => {
    if (initResult.data) {
      console.log("Has result right away");
      setData(initResult.data as OutputType);
    } else if (initResult.messageId) {
      console.log("Start polling");
      intervalHandle = setInterval(async () => {
        if (count > maxPoll && intervalHandle) clearInterval(intervalHandle);
        callQueue({
          method,
          data: input,
          messageId: initResult.messageId,
        }).then((pollingResult) => {
          if (pollingResult.data !== undefined) {
            console.log("Got result from polling, stop polling");
            if (intervalHandle) clearInterval(intervalHandle);
            setData(pollingResult.data as OutputType);
          }
        });
        count++;
      }, pollInterval);
    }
  });
  return intervalHandle;
}
